// ----------------------------------------------------------------------------
// Snippet: Shopify Predictive Search
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_predictive-search.scss';
var SEARCH_FORM = '.search-box';
var PREDICTIVE_SEARCH = '.predictive-search';
document.body.addEventListener('click', function (event) {
  var element = event.target;
  if (element.closest(SEARCH_FORM) == null) {
    var predictiveSearchResults = document.querySelectorAll(PREDICTIVE_SEARCH);
    predictiveSearchResults.forEach(predictiveSearchResult => {
      predictiveSearchResult.style.display = 'none';
    });
  }
});